import { createTheme } from '@mui/material/styles';

import {
  PublicoHeadlineBold,
  PublicoHeadlineLight,
  PublicoHeadlineMedium,
  SourceSansProBold,
  SourceSansProLight,
  SourceSansProMedium,
} from '../../assets/fonts';

// Helper to generate @font-face CSS string from font config object
const toFontFace = (font: {
  fontFamily: string;
  fontStyle: string;
  fontDisplay: string;
  fontWeight: string | number;
  src: string;
  unicodeRange?: string;
}) => `
  @font-face {
    font-family: '${font.fontFamily}';
    font-style: ${font.fontStyle};
    font-display: ${font.fontDisplay};
    font-weight: ${font.fontWeight};
    src: ${font.src};
    ${font.unicodeRange ? `unicode-range: ${font.unicodeRange};` : ''}
  }
`;

export default createTheme({
  typography: {
    fontFamily: 'Source Sans Pro',
  },
  palette: {
    primary: {
      main: '#F05D23',
      secondary: 'white',
    } as any,
    secondary: {
      main: '#C5D86D',
    },
    warning: {
      main: '#F07662',
    },
    text: {
      main: '#261C15',
    } as any,
    error: {
      main: '#C6132D',
    },
    action: {
      hover: '#E5E5E5',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        body {
          background-color: #F7F7F2 !important;
        }
        ${toFontFace(PublicoHeadlineBold)}
        ${toFontFace(PublicoHeadlineLight)}
        ${toFontFace(PublicoHeadlineMedium)}
        ${toFontFace(SourceSansProBold)}
        ${toFontFace(SourceSansProLight)}
        ${toFontFace(SourceSansProMedium)}
      `,
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: '#F07662 !important',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '0px',
          height: 48,
          fontFamily: 'Source Sans Pro',
          fontWeight: 700,
        },
        containedPrimary: {
          backgroundColor: '#F05D23',
          color: 'rgba(255, 255, 255, 1)',
        },
        containedDefault: {
          backgroundColor: 'rgba(255, 255, 255, 1)',
          color: 'rgba(51, 51, 51, 1)',
        },
        outlinedPrimary: {
          border: '1px solid #F05D23 !important',
          color: '#F05D23 !important',
        },
        outlinedDefault: {
          borderColor: 'rgba(255, 255, 255, 1) !important',
          color: 'rgba(255, 255, 255, 1) !important',
        },
      } as Record<string, any>,
    },
    MuiAutocomplete: {
      styleOverrides: {
        inputRoot: {
          padding: '0px !important',
        },
      },
    },
  },
  breakpoints: {
    values: {
      xxs: 0,
      xs: 320,
      sm: 576,
      md: 960,
      lg: 1200,
      xl: 1920,
    },
  },
});
